import AppConstants from '../constants/appConstants';
import { getLocalUser } from '../utils/auth';
import { authGet, authPut } from '../utils/fecth-wrappers';

class UrlService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  get myProfile() {
    const user = getLocalUser();
    return `${this.baseUrl}/v1/dealers/${user.getId()}`;
  }

  get updateProfile() {
    return `${AppConstants.API.icApiDealers}/my/profile`;
  }
}

export class UserProfileService {
  constructor(baseApiUrl) {
    this.urls = new UrlService(baseApiUrl);
  }

  async updateProfile({ phoneNumber, companyPhone, channel }) {
    // deliveryMethod: 'whatsapp' | 'call' (optional)
    const request = await authPut(this.urls.updateProfile, {
      companyPhone,
      personalPhone: phoneNumber,
      // pass verification method to backend so it can send OTP using desired channel
      verificationMethod: channel,
    });
    return request.data.data;
  }

  async getCurrentUserProfile() {
    const response = await authGet(this.urls.myProfile);
    return response?.body?.data ?? response?.data?.data ?? response?.data ?? response;
  }
}

export const userProfileService = new UserProfileService(
  AppConstants.baseURLs.baseIcApiDealers,
  AppConstants.USER_PROFILE_TTL_IN_DAYS
);
